<template>
  <v-toolbar
    class="accent"
    light
    card
    prominent>
    <v-btn
      v-if="backLink"
      :to="{ name: backLink }"
      exact
      icon
      light>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title>{{ title }}</v-toolbar-title>
    <v-btn
      v-if="action"
      :to="action"
      color="accent"
      dark
      absolute
      bottom
      right
      fab>
      <v-icon>add</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  name: "SecondaryToolbar",
  props: {
    title: {
      type: String,
      required: false,
      default: ""
    },
    backLink: {
      type: String,
      required: false,
      default: null
    },
    action: {
      type: Object,
      required: false,
      default: null
    }
  }
};
</script>
